import React from 'react';
import { useI18n } from '../i18n';

const GlobeIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-10-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

/**
 * Toggle between English and Arabic.
 * Shows the name of the language you switch TO, written in that language.
 *
 * variant: 'light' (default, for white backgrounds) | 'dark' (for dark backgrounds) | 'segmented'
 */
const LanguageSwitcher = ({ variant = 'light', className = '', compact = false }) => {
  const { lang, setLang, t } = useI18n();
  const nextLang = lang === 'ar' ? 'en' : 'ar';
  const nextLabel = nextLang === 'ar' ? 'العربية' : 'English';

  if (variant === 'segmented') {
    return (
      <div className={`inline-flex p-1 bg-slate-100 rounded-xl ${className}`} role="radiogroup" aria-label={t('Interface language')}>
        {[
          { code: 'en', label: 'English' },
          { code: 'ar', label: 'العربية' },
        ].map((option) => (
          <button
            key={option.code}
            type="button"
            role="radio"
            aria-checked={lang === option.code}
            onClick={() => setLang(option.code)}
            lang={option.code}
            className={`px-4 py-2 rounded-lg text-sm font-bold transition-all ${
              lang === option.code
                ? 'bg-white text-slate-900 shadow-sm'
                : 'text-slate-500 hover:text-slate-700'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    );
  }

  const styles = variant === 'dark'
    ? 'text-slate-300 hover:text-white hover:bg-white/10 border-white/15'
    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50 border-slate-200 bg-white';

  return (
    <button
      type="button"
      onClick={() => setLang(nextLang)}
      lang={nextLang}
      title={t('Interface language')}
      aria-label={t('Interface language')}
      className={`inline-flex items-center gap-1.5 rounded-xl border font-bold transition-colors ${
        compact ? 'h-9 px-2.5 text-xs' : 'h-9 px-3 text-sm'
      } ${styles} ${className}`}
    >
      <GlobeIcon size={compact ? 14 : 16} />
      <span>{nextLabel}</span>
    </button>
  );
};

export default LanguageSwitcher;
